var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMessagesPickerApplied = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2448 4.84479C15.594 5.49563 14.539 5.49563 13.8881 4.84479C13.2373 4.19396 13.2373 3.13896 13.8881 2.48813C14.539 1.83729 15.594 1.83729 16.2448 2.48813C16.8956 3.13896 16.8956 4.19479 16.2448 4.84479",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.98543 6.66699C8.14448 6.66699 6.6521 8.15938 6.6521 10.0003C6.6521 11.8413 8.14448 13.3337 9.98543 13.3337C11.8264 13.3337 13.3188 11.8413 13.3188 10.0003C13.3188 9.11627 12.9676 8.26842 12.3425 7.6433C11.7173 7.01818 10.8695 6.66699 9.98543 6.66699Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 16.2332C12.9341 17.0601 11.483 17.5007 9.99873 17.4987L10.0001 17.5001C7.97406 17.5 6.03425 16.6804 4.6221 15.2276C3.20995 13.7749 2.4456 11.8126 2.50302 9.78743C2.65574 5.82934 5.82934 2.65574 9.78743 2.50302C10.3669 2.48659 10.9413 2.53745 11.5001 2.65152M13.3334 6.66672V11.2501C13.3334 12.4007 14.2661 13.3334 15.4167 13.3334C15.9693 13.3334 16.4992 13.1139 16.8899 12.7232C17.2806 12.3325 17.5001 11.8026 17.5001 11.2501V10.0001C17.5001 8.97079 17.2885 7.96377 16.8899 7.03687",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMessagesPickerApplied);
export default ForwardRef;